<template>
  <div class="parcours-bandeau" :class="{ 'parcours-bandeau--compact': compact }" aria-label="Parcours du patient">
    <p v-if="chargement && !donnees" class="pb-chargement">Parcours…</p>
    <p v-else-if="erreur && !donnees" class="pb-erreur">{{ erreur }} <button type="button" class="btn btn-link btn-sm p-0" @click="charger">Réessayer</button></p>
    <ActionsParcours v-else :donnees="donnees" :maintenant="maintenant" @change="apresAction">
      <button type="button" class="btn btn-secondary-light-o ap-bouton" aria-label="Voir le parcours du patient" @click="ouvrirFrise">
        <i class="fa fa-route" aria-hidden="true"></i> Parcours
      </button>
    </ActionsParcours>
    <p v-if="info" class="pb-info" role="status">{{ info }}</p>
    <b-modal ref="friseModal" :title="'Parcours de ' + nomPatient" size="lg" hide-footer>
      <FriseParcours :etapes="donnees ? donnees.etapes : []" :position="donnees ? donnees.position : null" :maintenant="maintenant" />
    </b-modal>
  </div>
</template>

<script>
import api from '@/api/consultations/_parcours'
import ActionsParcours from '@/components/parcours/actions-parcours.vue'
import FriseParcours from '@/components/parcours/frise-parcours.vue'

// Dossier patient (04/10/2026) : où se trouve le patient et depuis quand, son parcours, et le transfert entre services.
export default {
  name: 'parcours-bandeau',
  components: { ActionsParcours, FriseParcours },
  props: { patientId: { type: Number, required: true }, compact: { type: Boolean, default: false } },
  data() {
    return { donnees: null, chargement: false, erreur: '', info: '', maintenant: new Date(), minuteur: null, minuteurInfo: null }
  },
  computed: {
    nomPatient() {
      const p = this.donnees && this.donnees.patient
      return p ? [String(p.nom || '').toUpperCase(), p.prenoms].filter(Boolean).join(' ') : 'patient'
    },
  },
  watch: { patientId() { this.charger() } },
  mounted() {
    this.charger()
    // Durées vivantes ; le parcours est relu chaque minute pour suivre les transferts faits ailleurs.
    let tours = 0
    this.minuteur = setInterval(() => {
      this.maintenant = new Date()
      if (++tours % 2 === 0) this.charger(true)
    }, 30000)
  },
  beforeDestroy() { clearInterval(this.minuteur); clearTimeout(this.minuteurInfo) },
  methods: {
    async charger(silencieux) {
      if (!this.patientId) return
      if (!silencieux) this.chargement = true
      try {
        const reponse = await api.parcoursPatient(this.patientId)
        this.donnees = reponse && reponse.data ? reponse.data : null
        this.erreur = ''
      } catch (erreur) {
        if (!silencieux) this.erreur = 'Le parcours n’a pas pu être chargé.'
      } finally {
        this.chargement = false
        this.maintenant = new Date()
      }
    },
    ouvrirFrise() {
      this.maintenant = new Date()
      if (this.$refs.friseModal) this.$refs.friseModal.show()
    },
    async apresAction(message) {
      // Confirmation passagère : elle s'efface après quelques secondes.
      this.info = message || ''
      clearTimeout(this.minuteurInfo)
      this.minuteurInfo = setTimeout(() => { this.info = '' }, 5000)
      await this.charger(true)
    },
  },
}
</script>

<style scoped>
.parcours-bandeau { margin-top: 12px; padding-top: 12px; border-top: 1px solid #edf0f6; }
.pb-chargement, .pb-erreur { margin: 0; color: var(--ui-text-secondary, #65728b); font-size: 13px; }
.pb-info { margin: 6px 0 0; color: #1e8e5a; font-size: 13px; }
@media screen {
  .parcours-bandeau--compact { margin: 12px 0; padding: 0 0 12px; border-top: 0; border-bottom: 1px solid #edf0f6; min-width: 0; }
  .parcours-bandeau--compact ::v-deep .ap-ligne { flex-direction: column; align-items: stretch; gap: 8px; }
  .parcours-bandeau--compact ::v-deep .ap-pastille { font-size: 13px; line-height: 1.4; padding: 7px 10px; border-radius: 12px; overflow-wrap: anywhere; }
  .parcours-bandeau--compact ::v-deep .ap-bouton,
  .parcours-bandeau--compact ::v-deep .ap-plier { width: 100%; min-height: 44px; padding: 8px 10px; font-size: 14px; line-height: 1.35; white-space: normal; overflow-wrap: anywhere; }
  .parcours-bandeau--compact ::v-deep .ap-bouton.btn-secondary-light-o { color: var(--ui-text-secondary, #273449); }
  .parcours-bandeau--compact ::v-deep .ap-confirmation { flex-wrap: wrap; min-width: 0; }
  .parcours-bandeau--compact ::v-deep .ap-panneau { padding: 10px; }
  .parcours-bandeau--compact ::v-deep .ap-choix button { max-width: 100%; white-space: normal; overflow-wrap: anywhere; }
  .parcours-bandeau--compact ::v-deep .ap-boutons { flex-wrap: wrap; }
  .parcours-bandeau--compact ::v-deep button:focus-visible { outline: 2px solid var(--ui-accent, #2457c5); outline-offset: 2px; }
}
</style>
